import Vue from 'vue';
import { phoneHide,clockTime } from "@/assets/js/common.js"



Vue.filter('fix',function(val){  //会员等级
    if(val||val===0){
        return parseFloat(val).toFixed(2)
    }else{
        return '--'
    }
    
})

Vue.filter('saleDeptCostType',function(val){  //会员等级
    switch(val){
                    case '0':
                    return '销售额比例';
                    case '1':
                    return '固定金额';
                    case '2':
                    return '毛利润比例';
                    default:
                        return '--'
                }
})


Vue.filter('Level',function(val){  //会员等级
    switch(val){
                    case '0':
                    return '未付费会员';
                    case '1':
                    return '普通会员';
                    case '2':
                    return '银卡会员';
                    case '3':
                    return '金卡会员';
                    case '4':
                    return '特惠会员';
                    case '5':
                    return '内部会员';
                }
})

Vue.filter('TagSize',function(val){  //用户规模标签
    switch(val){
                    case '0':
                    return '微企业';
                    case '1':
                    return '小型企业';
                    case '2':
                    return '中型企业';
                    case '3':
                    return '大型企业';
                }
})

Vue.filter('tagConsume',function(val){  //消费等级标签
    switch(val){
                    case '0':
                    return '普通消费';
                    case '1':
                    return '中等消费';
                    case '2':
                    return '大宗消费';
                }
})

Vue.filter('toFix',function(val){  //保留两位小数
if(val){
   return parseInt(val).toFixed(2)
}
})
